import { Grid, Paper } from '@mui/material'

import { FCWithChildren } from '@/types'

const FormCard: FCWithChildren = ({ children }) => {
  return (
    <Grid container sx={{ justifyContent: 'center' }}>
      <Grid size={{ xs: 12, md: 8, lg: 5 }}>
        <Paper sx={{ p: 5 }}>{children}</Paper>
      </Grid>
    </Grid>
  )
}

export default FormCard
